import axios from "../utils/axios";
import { buildFilterQueryString, buildSortingParams } from "../utils/query";

export const getClients = async ({ offset, limit, filters, sortModel } = {}) => {
  const filterQueryString = buildFilterQueryString(filters);
  const sortingParams = buildSortingParams(sortModel);
  const queryParts = [limit && `limit=${limit}`, offset && `offset=${offset}`, filterQueryString, sortingParams].filter(Boolean);
  const url = `/clients?${queryParts.join("&")}`;
  const { data: clients } = await axios.get(url);
  return clients;
};

export const removeClient = async (clientId) => {
  const { data: removedClient } = await axios.delete(`/clients/${clientId}`);
  return removedClient;
};

export const addClient = async ({ visualPath, ...client }) => {
  const formData = new FormData();
  formData.append("data", JSON.stringify(client));
  formData.append("file", visualPath);

  const { data: addedClient } = await axios.post(`/clients`, formData);

  return addedClient;
};

export const updateClient = async ({ id, visualPath, ...client }) => {
  const formData = new FormData();
  formData.append("data", JSON.stringify(client));
  formData.append("file", visualPath);

  const { data: updatedClient } = await axios.put(`/clients/${id}`, formData);

  return updatedClient;
};
